<template>
  <div class="page-container">
    <!-- 1. 原始显示区域（如图1） -->
    <div class="upload-box" @click="triggerFileInput">
      <!-- 如果已经有裁剪后的图片，显示它；否则显示相机图标 -->
      <img v-if="croppedImage" :src="croppedImage" class="preview-img" alt="Pet" />
      <div v-else class="placeholder-content">
        <div class="camera-icon">📷</div>
        <p>Click to add or take a photo of your pet</p>
      </div>
    </div>

    <!-- 隐藏的 input，用于触发选择文件 -->
    <input 
      ref="fileInputRef" 
      type="file" 
      accept="image/*" 
      style="display: none" 
      @change="handleFileChange"
    />

    <!-- 2. 裁剪弹窗（图2效果） -->
    <div v-if="isShowCropper" class="cropper-overlay">
      <div class="cropper-modal-content">
        <!-- 右上角关闭按钮 -->
        <button class="close-btn" @click="closeCropper">✖</button>
        
        <!-- vue-cropper 核心组件 -->
        <!-- 注意：这里的具体 props 需要配合 vue-cropper 官方文档微调 -->
        <vue-cropper
          ref="cropperRef"
          :img="imageSrc"
          :outputSize="1"
          :outputType="'png'"
          :canMove="true"
          :canMoveBox="true"
          :fixedBox="true"
          :autoCrop="true"
          :centerBox="true"
          :info="true"
          class="cropper-instance"
          fixed = "true"
          :fixedNumber="[1, 1]"
        ></vue-cropper>

        <!-- 底部操作按钮 -->
        <div class="cropper-actions">
          <button class="cancel-btn" @click="closeCropper">Cancel</button>
          <button class="confirm-btn" @click="confirmCrop">Crop & Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 需要先安装: npm install vue-cropper
import { VueCropper } from 'vue-cropper';
import 'vue-cropper/dist/index.css';

export default {
  name: 'PetPhotoCropper',
  components: {
    VueCropper
  },
  data() {
    return {
      isShowCropper: false,
      imageSrc: '',     // 原始图片路径 (用来传给裁剪组件)
      croppedImage: '', // 最终裁剪后的图片 (Base64 字符串)
    }
  },
  methods: {
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInputRef.click();
    },
    // 监听文件变化
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 使用 FileReader 将文件转为 base64 以供 vue-cropper 显示
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageSrc = event.target.result;
        this.isShowCropper = true; // 显示遮罩层和裁剪界面
        
        // 由于 input 选择同一个文件不会触发 change，重置一下 input
        e.target.value = ''; 
      };
      reader.readAsDataURL(file);
    },
    // 关闭裁剪弹窗
    closeCropper() {
      this.isShowCropper = false;
      this.imageSrc = '';
    },
    // 确认裁剪
    confirmCrop() {
      // 获取 vue-cropper 实例
      const cropperInstance = this.$refs.cropperRef;
      
      if (cropperInstance) {
        // 关键：获取裁剪后的 Base64 数据
        // getCropData 是 vue-cropper 提供的标准方法
        cropperInstance.getCropData((data) => {
          // data 就是裁剪后的 base64 字符串
          this.croppedImage = data; 
          
          // 可以在这里进行上传操作，或者把变量传给父组件
          // console.log("裁剪完成，变量已赋值:", this.croppedImage);
          
          this.$emit("crop", this.croppedImage)
          // 关闭弹窗
          this.closeCropper();
        });
      }
    }
  }
}
</script>

<style scoped>
/* 整个页面容器 */
.page-container {
  padding: 20px;
}

/* 图1：上传框样式 */
.upload-box {
  width: 400px;
  height: 400px;
  /* border: 2px dashed #ccc; */
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: #fafafa;
  overflow: hidden; /* 保证图片不溢出边框 */
  position: relative;
}

@media (max-width:895px) {
    .upload-box {
        width:320px;
        height:320px;
    }
    p {
      font-size:12px;
    }
}

.placeholder-content {
  text-align: center;
  color: #8c8c8c;
}
.camera-icon {
  font-size: 40px;
  margin-bottom: 10px;
}

/* 预览图片填充整个上传框 */
.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 图2：遮罩层与弹窗样式 */
.cropper-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85); /* 黑暗遮罩 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.cropper-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

/* 右上角红色关闭按钮 */
.close-btn {
  position: absolute;
  top: -50px;
  right: -50px;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 600px) {
  .close-btn { top: -40px; right: 0; }
}

/* 裁剪组件容器 */
.cropper-instance {
  width: 100%;
  height: 350px; /* 设置裁剪区高度 */
  background: #f0f0f0;
}

/* 底部按钮 */
.cropper-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}
.cropper-actions button {
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}
.cancel-btn {
  background: #f0f0f0;
  color: #666;
}
.confirm-btn {
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
  color: white;
}
</style>